import FeatureSplit from './components/FeatureSplit.vue'

export const REGISTERED_COMPONENTS = [
    {
        component: FeatureSplit,
        name: 'Half Feature',
        inputs: [
            {
                name: 'image',
                type: 'file',
                allowedFileTypes: ['jpg', 'png', 'svg', 'gif', 'webp', 'jpeg', 'avif'],
                required: true,
                defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a',
            },
            {
                name: 'imageAlt',
                friendlyName: 'Image Alt Text',
                type: 'string',
                required: true,
            },
            {
                name: 'heading',
                type: 'string',
                required: true,
            },
            {
                name: 'content',
                type: 'richText',
                required: true,
            },
            {
                name: 'direction',
                friendlyName: 'Show Image on',
                type: 'string',
                required: true,
                defaultValue: 'left',
                enum: ['left', 'right']
            },
        ]
    },
]
